import * as React from "react";
import { forwardRef } from "react";
const SvgFolder = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 6H20C21.1 6 22 6.9 22 8V13V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18L2.01 6C2.01 4.9 2.9 4 4 4H10L12 6Z", fill: "#202324", fillOpacity: 0.6 }));
const ForwardRef = forwardRef(SvgFolder);
export default ForwardRef;
